import { InboxIcon } from 'lucide-react';

import { EmptyBlock } from '@/components/ui/empty-block';

import { AuditLogsTable, AuditLogsFilters } from './';

import { useAuditLogs } from '../model';

const AuditLogsContainer = () => {
  const { nodesCount, dateRange, eventType } = useAuditLogs();

  if (!nodesCount && !dateRange && !eventType) {
    return (
      <EmptyBlock
        title="No activity yet"
        description="You'll see actions taken across your organization here once they start taking place."
        icon={InboxIcon}
        classes={{
          title: 'text-base',
          card: 'absolute top-0 left-0 w-full h-full [&>div]:h-full',
          content: 'h-full flex flex-col justify-center',
        }}
      />
    );
  }

  return (
    <div className="space-y-6">
      <AuditLogsFilters />
      <AuditLogsTable />
    </div>
  );
};

export default AuditLogsContainer;
